module.exports = __webpack_public_path__ + "static/media/Amendments-to-Covenants-Conditions-Restrictions-Trailwood.6c1078fc.pdf";